import { useEffect } from 'react';

import {
  Section,
  SectionLargerBlock,
  SectionSmallerBlock
} from '@/components/DybrComponents/Section';
import { DybrPageWrapper } from '@/components/DybrComponents/Wrappers';
import theme from '@/styles/DybrTheme';
import AboutDybr from './components/AboutDybr';
import DybrNews from './components/DybrNews';
import { InteractionBlock } from './components/InteractionBlock';
import InterestingList from './components/InterestingList';
import { LoginForm } from './components/LoginForm';
import { loggedOutInfo } from './components/StaticTexts';

export function MainLoggedOut() {
  useEffect(() => {
    document.title = 'Дыбр';
  }, []);

  return (
    <DybrPageWrapper main>
      <Section
        backgroundColor={theme.backgroundLighter}
        title="Блоги для всех и всего"
      >
        <AboutDybr />
      </Section>
      <Section
        backgroundColor={theme.backgroundLighter}
        withBackground
        title="С чего начать?"
      >
        <SectionLargerBlock>
          <InterestingList data={loggedOutInfo} />
        </SectionLargerBlock>
        <SectionSmallerBlock>
          <InteractionBlock>
            <LoginForm />
          </InteractionBlock>
        </SectionSmallerBlock>
      </Section>

      <Section lastSection>
        <DybrNews height={'300px'} />
      </Section>
    </DybrPageWrapper>
  );
}
